/* eslint-disable */
import React from "react";
import { Switch, Route, Redirect, Link } from "react-router-dom";
import Database from "variables/Database.js";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "components/Navbars/Navbar.js";
// import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
// import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import storeRedux from "store/store";
import routesTotal from "routes.js";

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

// import GridItem from "components/Grid/GridItem.js";
// import GridContainer from "components/Grid/GridContainer.js";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';

// import { breadcrumRoutes } from "routes.js";




import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

//import bgImage from "assets/img/boxside.jpg";
import bgImage from "assets/img/cantoli2.jpg";

import boxlogoside from "assets/img/cantolilogoside2.png";
//import boxlogoside from "assets/img/boxlogoside.png";


import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import logo_cantoli from '../assets/img/logo_cantoli_transparente.png'

import SvgIcon from '@material-ui/core/SvgIcon';

import ModalchangePass from './ModalChangePass';


let ps;

var setRoutesOut;
var setUserOut;
var setUserAlertasOut
var propsOut;


const useStyles = makeStyles(styles);
// const useStyles = makeStyles(theme => ({
//   root: {
//     height: '100vh',
//   },
//   image: {
//     // backgroundImage: 'url(/assets/imagenes/WH' + num + '.jpg)',
//    // backgroundImage: 'url(/assets/imagenes/cantoli' + num + '.jpg)',
//     backgroundRepeat: 'no-repeat',
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//   },
//   paper: {
//     margin: theme.spacing(8, 4),
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   avatar: {
//     margin: theme.spacing(1),
//     backgroundColor: theme.palette.secondary.main,
//   },
//   form: {
//     width: '100%', // Fix IE 11 issue.
//     marginTop: theme.spacing(1),
//   },
//   submit: {
//     margin: theme.spacing(3, 0, 2),
//   },

//   flexContainer: {
//     backgroundImage: 'url(/assets/imagenes/fondo.png)',
//     backgroundRepeat: 'no-repeat',
//     //backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '700px',
//     backgroundColor: 'black',
//   },

//   flexContainerDiv: {
//     margin: theme.spacing(8, 4),
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     backgroundColor: '#f1f1f1',
//     color: 'white',
//     // width: '50%',
//     // height: '50%',
//   }

// }));

toast.configure({
  position: toast.POSITION.BOTTOM_RIGHT,
  autoClose: 3500,
});


const meRoutes = () => {

  Database.get('/me', null, propsOut)
    .then(res => {

      console.log(res);

      let accesosUser = res.result[1].map(elem => {
        return parseInt(elem.id_acceso);
      });

      let alertasUser = res.result[2].map(elem => {
        return parseInt(elem.id_alerta);
      });
      let routesFilter = routesTotal.map(elem => {
        let indexAccesos = elem.accesos.findIndex(elem2 => {
          return (accesosUser.indexOf(elem2) > -1);
        })

        let indexAccesosAlertas = -1;
        if (elem.accesos_alertas) {
          indexAccesosAlertas = elem.accesos_alertas.findIndex(elem2 => {
            return (alertasUser.indexOf(elem2) > -1);
          })
        }


        if (indexAccesos > -1 || elem.accesos.length == 0 || indexAccesosAlertas > -1) {
          if (elem.groupComponent) {
            let dependences = elem.dependences.map(elem3 => {

              let indexAccesosDependences = elem3.accesos.findIndex(elem4 => {
                return (accesosUser.indexOf(elem4) > -1);
              })

              let indexAccesosAlertasDependences = -1;
              if (elem.accesos_alertas) {
                indexAccesosAlertasDependences = elem3.accesos_alertas.findIndex(elem5 => {
                  return (alertasUser.indexOf(elem5) > -1);
                })
              }


              if (indexAccesosDependences > -1 || indexAccesosAlertasDependences > -1 || elem3.accesos.length == 0) {
                elem3.show = true;
                return elem3
              }
              elem3.show = false
              return elem3
            })
            elem.show = true
            elem.dependences = dependences;
            return elem;

          } else {
            elem.show = true;
            return elem;
          }

        }
        elem.show = false;
        return elem;
      })

      setUserAlertasOut(res.result[2]);

      setUserOut(res.result[0][0]);

      setRoutesOut(routesFilter);


    }, err => {
      toast.error(err.message);
    })


}

storeRedux.subscribe(() => {
  meRoutes();
})




function Admin({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [routes, setRoutes] = React.useState([]);
  const [image, setImage] = React.useState(bgImage);
  const [user, setUser] = React.useState(null);
  const [userAlertas, setUserAlertas] = React.useState([]);
  const [color, setColor] = React.useState("green");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [openChangePass,setOpenChangePass] = React.useState(false);

  const [idUsersType, setIdUsersType] = React.useState(null);
  setRoutesOut = setRoutes;
  setUserOut = setUser;
  setUserAlertasOut = setUserAlertas
  propsOut = rest;


  React.useEffect(() => {
    Database.get('/me', null, rest)
    .then(res => {
      console.log(res);
      let id_users_type = res.result && res.result[0] && res.result[0][0] &&  res.result[0][0].id_users_type;
      setIdUsersType(id_users_type);
    })

  }, []);

 const linkBusqueda = (e) => {
    e.preventDefault();
    console.log(idUsersType);
    if(idUsersType == 50) {
        rest.history.push('/admin/cantolireclutamientolistado')
    } else {
      rest.history.push('/admin/reclutamientolistado')
    }
  }


  const linkPsicotecnicos = (e) => {
    e.preventDefault();
    
    rest.history.push('/admin/psicotecnicoslistado')
    
  }

  function mapBreadscrumRoutes(array) {
    return array.find(elem => {

      if (rest.location.pathname.indexOf(elem.path) > -1)
        return true;
      return false;
    })
  }

  const switchRoutes = (
    <Switch>
      {routes.map((prop, key) => {
        if (prop.show) {
          if (prop.layout === "/admin" && !prop.groupComponent) {
            return (
              <Route
                path={prop.layout + prop.path}
                component={prop.component}
                key={key}
              />
            );
          } else if (prop.groupComponent) {
            return prop.dependences.map((prop, key) => {
              if (prop.show) {
                return (
                  <Route
                    path={prop.layout + prop.path}
                    component={prop.component}
                    key={key}
                  />
                )
              }
            })

          }
          return null;
        }
      }
      )}
      {/* {  <Redirect exact from="/admin" to="/admin/dashboard" />} */}
      {<Route
        path="/admin"
        exact
        render={() => {
          return (
            <Grid container style={{ justifyContent: 'center' }}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className={classes.root}>
              <Grid item xs={12} sm={12} md={6}
                style={{ justifyContent: 'center', display: 'flex' }}
                alignItems="center">
                <Card style={{ width: '500px', margin: '50px' }} className={classes.root}>
                  <CardContent style={{ textAlign: 'center' }}>
                    <a href="#" onClick={ linkBusqueda } ><svg width="75" height="75" viewBox="0 0 50 50" style={{ marginTop: '0.5em' }}>
                      <path d="M29.668 18.1836C29.1397 18.1836 28.7109 18.6123 28.7109 19.1406C28.7109 19.6689 29.1397 20.0977 29.668 20.0977C30.1962 20.0977 30.625 19.6689 30.625 19.1406C30.625 18.6123 30.1962 18.1836 29.668 18.1836Z" fill="#FFB74D" />
                      <path d="M47.8785 42.4653L35.104 29.6908C37.1851 26.5562 38.2812 22.9262 38.2812 19.1406C38.2812 8.58648 29.6948 0 19.1406 0C8.58648 0 0 8.58648 0 19.1406C0 29.6948 8.58648 38.2812 19.1406 38.2812C22.9263 38.2812 26.5563 37.185 29.6908 35.1041L33.2218 38.6351C33.2223 38.6355 33.2228 38.636 33.2233 38.6366L42.4652 47.8785C43.1885 48.6017 44.1497 49 45.1719 49C46.1941 49 47.1552 48.6017 47.8782 47.8787C48.6016 47.1559 49 46.1947 49 45.1719C49 44.1491 48.6016 43.1879 47.8785 42.4653ZM29.2408 33.0872C29.2408 33.0872 29.2407 33.0872 29.2406 33.0873C26.2865 35.233 22.7941 36.3672 19.1406 36.3672C9.6419 36.3672 1.91406 28.6394 1.91406 19.1406C1.91406 9.6419 9.6419 1.91406 19.1406 1.91406C28.6394 1.91406 36.3672 9.6419 36.3672 19.1406C36.3672 22.7941 35.233 26.2865 33.0872 29.2407C32.0137 30.7196 30.7197 32.0137 29.2408 33.0872ZM31.2486 33.9548C32.2391 33.1445 33.1446 32.239 33.9548 31.2486L36.67 33.9638C35.8443 34.9383 34.9383 35.8444 33.9638 36.67L31.2486 33.9548ZM46.525 46.525C46.1633 46.8868 45.6827 47.0859 45.1719 47.0859C44.661 47.0859 44.1805 46.8868 43.8187 46.525L35.3208 38.0271C36.29 37.1953 37.1953 36.2901 38.027 35.3209L46.5252 43.8191C46.8868 44.1803 47.0859 44.6606 47.0859 45.1719C47.0859 45.6831 46.8868 46.1635 46.525 46.525Z" fill="#FFB74D" />
                      <path d="M19.1406 3.82812C10.6972 3.82812 3.82812 10.6972 3.82812 19.1406C3.82812 27.584 10.6972 34.4531 19.1406 34.4531C27.584 34.4531 34.4531 27.584 34.4531 19.1406C34.4531 10.6972 27.584 3.82812 19.1406 3.82812ZM19.1406 32.5391C11.7527 32.5391 5.74219 26.5285 5.74219 19.1406C5.74219 11.7527 11.7527 5.74219 19.1406 5.74219C26.5285 5.74219 32.5391 11.7527 32.5391 19.1406C32.5391 26.5285 26.5285 32.5391 19.1406 32.5391Z" fill="#FFB74D" />
                      <path d="M29.8656 15.0324C29.0415 12.8875 27.6066 11.0536 25.7159 9.72918C23.7802 8.37307 21.5065 7.65625 19.1406 7.65625C18.6122 7.65625 18.1836 8.08481 18.1836 8.61328C18.1836 9.14175 18.6122 9.57031 19.1406 9.57031C23.0739 9.57031 26.6659 12.0412 28.0789 15.719C28.2252 16.0995 28.5878 16.333 28.9725 16.333C29.0866 16.333 29.2027 16.3124 29.3155 16.2691C29.8089 16.0795 30.0552 15.5258 29.8656 15.0324Z" fill="#FFB74D" />
                    </svg></a>

                    <p style={{ fontSize: '30px', fontWeight: '400', lineHeight: '2rem', marginTop: '0.5em' }} ><a style={{ color: 'FFFFFF' }} onClick= { linkBusqueda } href="#">Búsqueda y Selección</a></p>
                  </CardContent>

                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6}
                style={{ justifyContent: 'center', display: 'flex' }}
                alignItems="center">
                <Card style={{ width: '500px', margin: '50px' }} className={classes.root}>
                  <CardContent style={{ textAlign: 'center' }}>

                    <a href="#" onClick={ linkPsicotecnicos } >

                      <svg width="75" height="75" viewBox="0 0 50 50" style={{ marginTop: '0.5em' }} fill="none" xmlns="http://www.w3.org/2000/svg">

                        <path d="M46.9583 18.8381C47.0065 16.4976 46.7185 14.1624 46.1033 11.9038C45.278 9.09643 43.5651 6.6322 41.2212 4.88042C36.6112 1.2683 32.3024 -0.228648 27.2652 0.0269682C24.6081 0.210985 21.9679 0.588469 19.3656 1.15642C15.6816 1.89714 13.0054 3.19237 11.1834 5.11644C9.73956 6.65397 8.62465 8.47 7.90697 10.4534C7.60276 11.3272 7.35507 12.2198 7.16543 13.1255L7.1001 13.4081C6.92809 14.0442 6.69593 14.6624 6.40675 15.2545C6.23852 15.6318 6.06947 16.0091 5.92328 16.3979C5.73395 16.8292 5.65832 17.3018 5.7036 17.7707C5.86976 18.5002 6.29264 19.1457 6.89512 19.5894C7.2961 19.9569 7.55907 20.2142 7.56152 20.4494C7.52958 20.5712 7.48152 20.6882 7.4186 20.7973C6.4406 22.8593 5.2418 24.8092 3.84323 26.6127C3.25687 27.329 2.64273 28.1644 2.76768 29.0129C2.94616 29.6568 3.37137 30.2044 3.95103 30.5368C4.22126 30.7229 4.50612 30.8868 4.80282 31.0268C5.1548 31.2065 5.74525 31.507 5.78282 31.7234C5.83575 31.9984 5.80473 32.283 5.6938 32.5401C5.57212 32.7949 5.4488 33.0154 5.33855 33.2073C5.03883 33.7373 4.53658 34.6259 5.292 35.2612C5.4684 35.4164 5.77057 35.6541 6.0466 35.8656C5.84264 36.2243 5.75103 36.6359 5.78363 37.0473C5.82796 37.367 6.00192 37.6544 6.26465 37.8419C6.44758 37.9718 6.64277 38.0869 6.83632 38.1947C7.31652 38.4683 7.50353 38.5965 7.57132 38.848C7.61538 39.1807 7.58526 39.519 7.48312 39.8387C7.43575 40.0534 7.39002 40.2674 7.36143 40.4814C7.27868 41.2242 7.37241 41.976 7.63502 42.6758C8.05731 44.2279 9.6215 45.1771 11.1932 44.835C13.5251 44.2727 15.8249 43.5849 18.0826 42.7746C19.9185 43.8591 21.079 47.1397 21.3811 48.3704C21.4707 48.7356 21.798 48.9926 22.1741 48.9927L42.6725 48.9363C42.931 48.9355 43.1739 48.8123 43.3273 48.6042C43.4807 48.3961 43.5265 48.1276 43.4508 47.8804C43.2483 47.323 42.9681 46.7971 42.6186 46.3181C42.4255 46.041 42.2509 45.7516 42.0959 45.4516C41.7277 44.6984 41.4192 43.9174 41.1731 43.1159C40.7069 41.5384 40.3849 39.9219 40.211 38.2862C39.9216 35.8441 40.2904 33.3691 41.2792 31.1175C41.8837 29.8707 42.6275 28.6965 43.4965 27.6172C43.9865 26.9533 44.4985 26.2673 44.9575 25.5429C46.2463 23.5427 46.9402 21.2174 46.9583 18.8381ZM42.1857 26.6511C41.2422 27.8291 40.4361 29.1108 39.7831 30.4715C38.678 32.9901 38.2664 35.7583 38.5908 38.4895C38.7736 40.2221 39.1142 41.9344 39.6083 43.6051C39.879 44.4853 40.2176 45.3432 40.621 46.1711C40.8068 46.5364 41.0171 46.8886 41.2507 47.2254L41.3094 47.3144L22.7915 47.3667C22.2475 45.4288 21.2622 43.6432 19.9128 42.1498C20.121 42.0771 20.3211 42.0094 20.5016 41.944C21.1206 41.7276 21.5886 41.5635 21.8221 41.49C25.3232 40.3907 27.0741 38.7999 27.0268 36.7606C27.0003 36.3166 26.6353 35.9684 26.1905 35.9628C25.9739 35.9679 25.7682 36.0589 25.6187 36.2157C25.4692 36.3726 25.3882 36.5824 25.3934 36.799C25.413 37.6402 24.7246 38.8668 21.3313 39.9318C21.0863 40.0085 20.6037 40.1768 19.961 40.403C19.3787 40.6071 18.6641 40.857 17.8825 41.1241C15.5821 41.9561 13.2384 42.6633 10.8617 43.2425C10.0965 43.39 9.35175 42.9057 9.17607 42.1466C8.99971 41.6881 8.93234 41.1949 8.97925 40.706C9.0013 40.5369 9.03968 40.3679 9.07725 40.198C9.24481 39.6312 9.27117 39.0321 9.15402 38.4528C8.91958 37.7029 8.36961 37.0927 7.64808 36.7819L7.47332 36.6814C7.56077 36.5031 7.66554 36.3338 7.7861 36.1759C7.92196 36.0024 7.98194 35.7814 7.95241 35.563C7.92288 35.3446 7.80636 35.1474 7.6293 35.0162C7.4333 34.8709 6.96617 34.5213 6.63133 34.2527C6.67298 34.1767 6.71953 34.0893 6.76282 34.0166C6.88858 33.7953 7.0315 33.5397 7.17115 33.2482C7.43235 32.6771 7.50913 32.0388 7.39083 31.4221C7.20055 30.42 6.2475 29.9317 5.54435 29.5756C5.30728 29.4632 5.08 29.3313 4.86488 29.1812C4.69561 29.0634 4.53512 28.9335 4.38468 28.7924C4.38468 28.6699 4.51535 28.371 5.14337 27.6042C6.60254 25.7228 7.85362 23.6888 8.87472 21.538C9.07135 21.2013 9.18134 20.8211 9.19485 20.4314C9.1116 19.6093 8.67492 18.8641 7.99843 18.3897C7.67177 18.0876 7.35653 17.8017 7.32142 17.5502C7.32466 17.3526 7.36916 17.1579 7.45208 16.9785C7.58602 16.6241 7.742 16.2762 7.89798 15.9283C8.2309 15.2413 8.49647 14.5236 8.69097 13.7854L8.75712 13.5003C8.93151 12.662 9.15956 11.8358 9.43985 11.0267C10.08 9.24799 11.0768 7.6189 12.3692 6.23935C13.9511 4.57335 16.3456 3.43002 19.6874 2.7579C22.211 2.20562 24.7715 1.83823 27.3485 1.65867C31.9692 1.41367 35.9358 2.81344 40.2118 6.1683C42.2897 7.70021 43.8067 9.87228 44.5296 12.3505C45.1025 14.456 45.3704 16.6328 45.325 18.8144C45.3107 20.8948 44.7048 22.9282 43.5781 24.6772C43.1502 25.3485 42.6586 26.0109 42.1833 26.6511H42.1857Z" fill="#FFB74D" />
                        <path d="M19.1916 13.8833H20.0083C20.4593 13.8833 20.825 13.5177 20.825 13.0667C20.825 12.6156 20.4593 12.25 20.0083 12.25H19.1916C17.8385 12.25 16.7416 13.3469 16.7416 14.7V15.5167C16.7416 16.8698 17.8385 17.9667 19.1916 17.9667H20.0083C20.4593 17.9667 20.825 17.601 20.825 17.15C20.825 16.699 20.4593 16.3333 20.0083 16.3333H19.1916C18.7406 16.3333 18.375 15.9677 18.375 15.5167V14.7C18.375 14.249 18.7406 13.8833 19.1916 13.8833Z" fill="#FFB74D" />
                        <path d="M24.9084 11.4333C24.4573 11.4333 24.0917 11.799 24.0917 12.25V13.8833C24.0917 14.3344 23.7261 14.7 23.275 14.7H22.4584C22.0073 14.7 21.6417 15.0656 21.6417 15.5167C21.6417 15.9677 22.0073 16.3333 22.4584 16.3333H23.275C24.6281 16.3333 25.725 15.2364 25.725 13.8833V12.25C25.725 11.799 25.3594 11.4333 24.9084 11.4333Z" fill="#FFB74D" />
                        <path d="M28.175 11.4334V10.6167C28.175 9.26365 27.0781 8.16675 25.725 8.16675H24.0917C22.7386 8.16675 21.6417 9.26365 21.6417 10.6167V11.4334C21.6417 11.8844 22.0073 12.2501 22.4584 12.2501C22.9094 12.2501 23.275 11.8844 23.275 11.4334V10.6167C23.275 10.1657 23.6407 9.80008 24.0917 9.80008H25.725C26.1761 9.80008 26.5417 10.1657 26.5417 10.6167V11.4334C26.5417 11.8844 26.9073 12.2501 27.3584 12.2501C27.8094 12.2501 28.175 11.8844 28.175 11.4334Z" fill="#FFB74D" />
                        <path d="M30.625 17.1501H29.8083C29.3573 17.1501 28.9916 16.7844 28.9916 16.3334V15.5167C28.9916 15.0657 28.626 14.7001 28.175 14.7001C27.7239 14.7001 27.3583 15.0657 27.3583 15.5167V16.3334C27.3583 17.6865 28.4552 18.7834 29.8083 18.7834H30.625C31.076 18.7834 31.4417 18.4178 31.4417 17.9667C31.4417 17.5157 31.076 17.1501 30.625 17.1501Z" fill="#FFB74D" />
                        <path d="M34.7083 14.7C34.7083 14.249 34.3427 13.8834 33.8917 13.8834H33.075C32.624 13.8834 32.2583 13.5177 32.2583 13.0667C32.2583 12.6157 32.624 12.25 33.075 12.25H33.8917C34.3427 12.25 34.7083 11.8844 34.7083 11.4334C34.7083 10.9823 34.3427 10.6167 33.8917 10.6167H33.075C31.7219 10.6167 30.625 11.7136 30.625 13.0667C30.625 14.4198 31.7219 15.5167 33.075 15.5167H33.8917C34.3427 15.5167 34.7083 15.1511 34.7083 14.7Z" fill="#FFB74D" />
                        <path d="M37.1584 14.7001C36.7073 14.7001 36.3417 15.0657 36.3417 15.5167V17.1501C36.3417 17.6011 35.9761 17.9667 35.525 17.9667H34.7084C34.2573 17.9667 33.8917 18.3324 33.8917 18.7834C33.8917 19.2344 34.2573 19.6001 34.7084 19.6001H35.525C36.8781 19.6001 37.975 18.5032 37.975 17.1501V15.5167C37.975 15.0657 37.6094 14.7001 37.1584 14.7001Z" fill="#FFB74D" />
                        <path d="M43.659 17.1501C43.659 17.137 43.6525 17.1264 43.6517 17.1133C43.5784 15.654 43.3462 14.207 42.9591 12.798C42.3279 10.6548 41.01 8.77823 39.2082 7.45704C35.5144 4.55951 32.1652 3.26672 28.3457 3.26672C28.0452 3.26672 27.7414 3.27489 27.4302 3.28959C27.1517 3.30429 26.8732 3.33614 26.5948 3.35901C26.576 3.35901 26.5605 3.34839 26.5417 3.34839C26.4988 3.35312 26.4565 3.36159 26.4151 3.37371C24.2626 3.58132 22.1236 3.91042 20.0083 4.35942C19.0806 4.54214 18.1678 4.79355 17.2774 5.11157C17.2586 5.11892 17.2398 5.12301 17.2219 5.13117C15.8451 5.58407 14.591 6.34777 13.5567 7.36312C12.5554 8.43841 11.7579 9.68668 11.203 11.0471C11.178 11.0932 11.1575 11.1416 11.1418 11.1917C11.0871 11.3256 11.0242 11.4522 10.9736 11.5886C10.7228 12.2688 10.3284 13.9626 10.2786 14.1758C10.0948 15.0896 9.63912 18.2215 11.4921 20.1864C12.6681 21.4327 14.4664 21.8933 16.8282 21.5584L17.9275 21.4016C23.1672 20.6478 25.7969 20.2697 28.0599 22.4829C28.4951 22.9084 28.941 23.3428 29.4049 23.7651C28.8912 25.3804 28.2248 28.8284 30.9566 30.8701C33.8917 33.0751 33.8917 33.672 33.8917 35.1167C33.8901 35.4005 34.036 35.6648 34.277 35.8147C34.518 35.9646 34.8195 35.9786 35.0734 35.8517C35.2874 35.7407 37.1583 34.6986 37.1583 31.0334C37.1583 29.0285 38.6528 27.2955 40.1286 25.8614L40.1531 25.8394C40.9533 25.2901 41.6454 24.598 42.1947 23.7977C42.7872 22.8638 43.211 21.833 43.4467 20.7524C43.4949 20.647 43.52 20.5326 43.5202 20.4167C43.6227 19.881 43.6801 19.3377 43.6917 18.7924C43.6998 18.2444 43.6876 17.7013 43.6582 17.1648C43.6588 17.1599 43.6591 17.155 43.659 17.1501ZM35.525 31.0334C35.5389 31.7126 35.4418 32.3895 35.2375 33.0375C34.8562 32.0828 33.9725 31.0938 31.9317 29.5626C30.309 28.3474 30.4233 26.3269 30.7736 24.9076C32.3037 26.1357 34.2017 26.8147 36.1636 26.8357C36.4818 26.8334 36.7996 26.8148 37.1159 26.7802C36.1346 27.9857 35.5758 29.4798 35.525 31.0334ZM40.817 22.9272C40.2455 23.7838 39.4371 24.4557 38.4903 24.861C36.9915 25.3435 35.3755 25.3194 33.8917 24.7924V23.6834C33.8917 23.2324 34.2573 22.8667 34.7083 22.8667H37.1583C37.6094 22.8667 37.975 22.5011 37.975 22.0501C37.975 21.599 37.6094 21.2334 37.1583 21.2334H34.7083C33.3552 21.2334 32.2583 22.3303 32.2583 23.6834V23.9374C31.1615 23.1581 30.1378 22.2807 29.1999 21.3159C28.2518 20.3548 27.0443 19.6905 25.725 19.4041V18.7834C25.725 18.3324 25.3594 17.9667 24.9083 17.9667C24.4573 17.9667 24.0917 18.3324 24.0917 18.7834V19.2048C21.9459 19.2091 19.8046 19.4034 17.6931 19.7854L16.5971 19.9414C16.1044 20.014 15.6059 20.0397 15.1083 20.0182V19.6001C15.1083 19.149 14.7427 18.7834 14.2917 18.7834C13.8406 18.7834 13.475 19.149 13.475 19.6001V19.6393C13.1768 19.4983 12.9065 19.3046 12.6771 19.0676C12.2091 18.5261 11.9096 17.8596 11.8155 17.1501H12.6583C14.0114 17.1501 15.1083 16.0532 15.1083 14.7001C15.1083 14.249 14.7427 13.8834 14.2917 13.8834C13.8406 13.8834 13.475 14.249 13.475 14.7001C13.475 15.1511 13.1094 15.5167 12.6583 15.5167H11.7429C11.7651 15.1825 11.8084 14.85 11.8727 14.5212C11.9797 14.0573 12.281 12.8062 12.4713 12.2501H15.1083C15.5594 12.2501 15.925 11.8844 15.925 11.4334C15.925 10.9824 15.5594 10.6167 15.1083 10.6167H13.2153C13.6294 9.84363 14.1419 9.12745 14.74 8.48604C15.3183 7.90706 15.9964 7.43728 16.7417 7.09934V8.16672C16.7417 9.51982 17.8386 10.6167 19.1917 10.6167C19.6427 10.6167 20.0083 10.2511 20.0083 9.80006C20.0083 9.34902 19.6427 8.98339 19.1917 8.98339C18.7406 8.98339 18.375 8.61776 18.375 8.16672V6.45989C19.019 6.25895 19.6732 6.09265 20.335 5.96172C21.0308 5.82126 21.7429 5.68651 22.4583 5.55829V5.71672C22.4583 6.16776 22.824 6.53339 23.275 6.53339C23.726 6.53339 24.0917 6.16776 24.0917 5.71672V5.28634C24.6356 5.20467 25.1803 5.12954 25.725 5.06992V5.71672C25.725 6.16776 26.0906 6.53339 26.5417 6.53339C26.9927 6.53339 27.3583 6.16776 27.3583 5.71672V4.93436C27.4098 4.93436 27.4621 4.92456 27.5127 4.92129C28.0174 4.90006 28.5082 4.90006 28.9917 4.92047V8.16672C28.9917 8.61776 29.3573 8.98339 29.8083 8.98339H31.4417C31.8927 8.98339 32.2583 8.61776 32.2583 8.16672C32.2583 7.71569 31.8927 7.35006 31.4417 7.35006H30.625V5.09851C32.0539 5.34066 33.4356 5.80701 34.719 6.48031C34.719 6.49909 34.7083 6.51461 34.7083 6.53339V8.98339C34.7083 9.43442 35.074 9.80006 35.525 9.80006C35.976 9.80006 36.3417 9.43442 36.3417 8.98339V7.42356C36.8774 7.77064 37.4197 8.14957 37.975 8.57669V10.6167C37.975 11.0678 37.6094 11.4334 37.1583 11.4334C36.7073 11.4334 36.3417 11.799 36.3417 12.2501C36.3417 12.7011 36.7073 13.0667 37.1583 13.0667C38.5114 13.0667 39.6083 11.9698 39.6083 10.6167V10.0573C40.4383 10.9682 41.0472 12.058 41.3879 13.2423C41.6648 14.2542 41.8517 15.2886 41.9465 16.3334H40.425C39.974 16.3334 39.6083 16.699 39.6083 17.1501C39.6083 17.6011 39.974 17.9667 40.425 17.9667H42.0412C42.0469 18.2338 42.06 18.4992 42.0559 18.7687C42.0518 19.0529 42.0208 19.3265 41.9897 19.6001H40.425C39.974 19.6001 39.6083 19.9657 39.6083 20.4167C39.6083 20.8678 39.974 21.2334 40.425 21.2334H41.6206C41.4202 21.8276 41.1504 22.3961 40.817 22.9272Z" fill="#FFB74D" />

                      </svg>



                    </a>
                    <p style={{ fontSize: '30px', fontWeight: '400', lineHeight: '2rem', marginTop: '0.5em' }} ><a style={{ color: 'FFFFFF' }} onClick= { linkPsicotecnicos } href="#">Evaluaciones Psicológicas</a></p>
                  </CardContent>

                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6}
                style={{ justifyContent: 'center', display: 'flex' }}
                alignItems="center">
                <Card style={{ width: '500px', margin: '50px' }} className={classes.root}>
                  <CardContent style={{ textAlign: 'center' }}>
                    <a href="#" ><svg width="75" height="75" viewBox="0 0 50 50" style={{ marginTop: '0.5em' }} fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M46.8356 37.5294C46.9964 37.3648 47.1495 37.1918 47.285 37.005C48.0966 35.8787 48.4028 34.5151 48.1394 33.1171L47.2972 29.7866C46.6281 27.1391 44.6903 25.0872 42.2319 24.2068C43.548 23.2283 44.4062 21.6672 44.4062 19.9062C44.4062 16.9517 42.0014 14.5469 39.0469 14.5469C36.0923 14.5469 33.6875 16.9517 33.6875 19.9062C33.6875 21.4053 34.3084 22.7613 35.3037 23.7344L29.4766 23.7351C27.9989 23.7351 26.7969 24.9364 26.7969 26.4141C26.7969 26.8267 26.8987 27.2134 27.0664 27.5625H25.2656V18.2364L27.3833 17.813C30.5921 17.1714 32.9219 14.3302 32.9219 11.0564V3.44531C32.9219 1.96766 31.7198 0.765625 30.2422 0.765625C28.7645 0.765625 27.5625 1.96766 27.5625 3.44531V9.95312C27.5625 11.2195 26.532 12.25 25.2656 12.25H22.8838C23.8798 11.2761 24.5 9.92097 24.5 8.42188C24.5 5.46733 22.0952 3.0625 19.1406 3.0625C16.1861 3.0625 13.7813 5.46733 13.7813 8.42188C13.7813 10.0465 14.5109 11.502 15.6563 12.4858C14.1158 12.8533 12.7063 13.6534 11.5854 14.8034C11.0702 14.638 10.5228 14.5469 9.95313 14.5469C6.99858 14.5469 4.59375 16.9517 4.59375 19.9062C4.59375 21.6672 5.45202 23.2283 6.76736 24.206C4.30894 25.0872 2.37191 27.1383 1.70199 29.7859L0.850612 33.1615C0.59719 34.5144 0.904205 35.8787 1.715 37.0042C1.85052 37.1918 2.00288 37.3648 2.16442 37.5286C1.38272 37.5975 0.765627 38.2483 0.765627 39.0469V40.5781C0.765627 41.4226 1.45239 42.1094 2.29688 42.1094H5.35938V46.7031H3.82813V48.2344H11.4844V46.7031H9.95313V42.1094H10.5786L11.5518 45.8135C11.8526 47.2161 13.1121 48.2344 14.5461 48.2344C14.7582 48.2344 14.9726 48.2122 15.1862 48.167C15.9878 47.9947 16.6738 47.5223 17.1186 46.8348C17.5627 46.1488 17.7127 45.3288 17.532 44.4943L15.7627 37.7637C15.3814 35.9867 14.22 34.5251 12.6941 33.6875H21.4375V48.2344H27.5625V33.6875H36.3029C34.7785 34.522 33.6209 35.9752 33.245 37.73L31.4595 44.5272C31.2865 45.3288 31.4373 46.148 31.8814 46.8348C32.3262 47.5223 33.013 47.9955 33.8177 48.1678C34.0274 48.2122 34.2418 48.2344 34.4539 48.2344C35.8879 48.2344 37.1474 47.2161 37.4391 45.8472L38.4214 42.1094H39.8125V46.7031H38.2812V48.2344H45.9375V46.7031H44.4062V42.1094H46.7031C47.5476 42.1094 48.2344 41.4226 48.2344 40.5781V39.0469C48.2344 38.2483 47.6173 37.5975 46.8356 37.5294ZM35.2188 19.9062C35.2188 17.7954 36.936 16.0781 39.0469 16.0781C41.1577 16.0781 42.875 17.7954 42.875 19.9062C42.875 22.0171 41.1577 23.7344 39.0469 23.7344C36.936 23.7344 35.2188 22.0171 35.2188 19.9062ZM29.4827 29.0938H30.6357H36.9537L37.916 32.1562H11.084L12.0463 29.0938H18.3765H19.5173H29.4827ZM19.8833 20.3779L19.1406 21.1205L18.398 20.3779L18.8688 13.7812H19.4132L19.8833 20.3779ZM15.3125 8.42188C15.3125 6.31105 17.0298 4.59375 19.1406 4.59375C21.2515 4.59375 22.9688 6.31105 22.9688 8.42188C22.9688 10.5327 21.2515 12.25 19.1406 12.25C17.0298 12.25 15.3125 10.5327 15.3125 8.42188ZM17.333 13.7966L16.8208 20.9659L19.1406 23.2857L21.4605 20.9659L20.9475 13.7812H25.2656C27.3765 13.7812 29.0938 12.064 29.0938 9.95312V3.44531C29.0938 2.81214 29.609 2.29688 30.2422 2.29688C30.8754 2.29688 31.3906 2.81214 31.3906 3.44531V11.0564C31.3906 13.6021 29.5792 15.8125 27.0825 16.3116L23.7344 16.9823V27.5625H21.9336C22.1013 27.2134 22.2031 26.8267 22.2031 26.4141C22.2031 24.9364 21.0011 23.7351 19.5234 23.7351L13.6963 23.7344C14.6916 22.7613 15.3125 21.4053 15.3125 19.9062C15.3125 18.0986 14.4098 16.5 13.0348 15.5292C14.2207 14.4741 15.7344 13.8609 17.333 13.7966ZM6.125 19.9062C6.125 17.7954 7.8423 16.0781 9.95313 16.0781C12.064 16.0781 13.7813 17.7954 13.7813 19.9062C13.7813 22.0171 12.064 23.7344 9.95313 23.7344C7.8423 23.7344 6.125 22.0171 6.125 19.9062ZM8.42188 46.7031H6.89063V42.1094H8.42188V46.7031ZM2.29688 40.5781V39.0469H5.89455L9.78316 39.0821L10.1767 40.5781H2.29688ZM14.2751 38.1189L16.0444 44.8503C16.1302 45.25 16.0559 45.6603 15.8339 46.0033C15.6119 46.3471 15.2681 46.5845 14.8692 46.6694C14.0446 46.8425 13.2254 46.3035 13.0417 45.4582L11.2723 38.7253C11.1199 38.0248 10.4906 37.5156 9.77474 37.5156H6.89369H5.89455C4.69099 37.5156 3.59231 36.9896 2.95761 36.1084C2.39411 35.3267 2.17974 34.3804 2.34511 33.4907L3.1873 30.161C3.91541 27.2792 6.50092 25.2656 9.47461 25.2656L19.5234 25.2664C20.1566 25.2664 20.6719 25.7817 20.6719 26.4141C20.6719 27.0472 20.1535 27.5625 19.5173 27.5625H18.3765H10.9224L8.75875 34.4501L9.79617 34.4554C11.9369 34.4661 13.8172 35.9928 14.2751 38.1189ZM26.0312 46.7031H22.9688V33.6875H26.0312V46.7031ZM35.9507 45.4919C35.7769 46.2989 34.9309 46.8371 34.1354 46.6702C33.7334 46.5845 33.3889 46.3471 33.1669 46.0033C32.9448 45.6603 32.8698 45.2507 32.9479 44.8832L34.7333 38.0853C35.1828 35.9928 37.0631 34.4654 39.2038 34.4554L40.2412 34.4501L38.0776 27.5625H30.635H29.4819C28.8465 27.5625 28.3281 27.0472 28.3281 26.4141C28.3281 25.7817 28.8434 25.2664 29.4766 25.2664L38.2812 25.2656H39.5254C42.4991 25.2656 45.0846 27.2792 45.8127 30.1618L46.6449 33.4456C46.8203 34.3812 46.6059 35.3267 46.0424 36.1092C45.4077 36.9896 44.309 37.5156 43.1054 37.5156H41.3438H39.2253C38.5086 37.5156 37.8793 38.0248 37.7361 38.6932L35.9507 45.4919ZM42.875 46.7031H41.3438V42.1094H42.875V46.7031ZM46.7031 40.5781H38.8233L39.2253 39.0469H41.3438H43.1054H46.7031V40.5781Z" fill="#FFB74D" />
                      <path d="M37.5156 6.89062H39.0469V8.42188H37.5156V6.89062Z" fill="#FFB74D" />
                      <path d="M40.5781 6.89062H42.1094V8.42188H40.5781V6.89062Z" fill="#FFB74D" />
                      <path d="M43.6406 6.89062H45.1719V8.42188H43.6406V6.89062Z" fill="#FFB74D" />
                      <path d="M45.9375 3.82812H36.75C35.4837 3.82812 34.4531 4.85866 34.4531 6.125V9.1875C34.4531 10.4538 35.4837 11.4844 36.75 11.4844H39.0469V14.3685L43.8527 11.4844H45.9375C47.2038 11.4844 48.2344 10.4538 48.2344 9.1875V6.125C48.2344 4.85866 47.2038 3.82812 45.9375 3.82812ZM46.7031 9.1875C46.7031 9.61013 46.3601 9.95312 45.9375 9.95312H43.4285L40.5781 11.6628V9.95312H36.75C36.3274 9.95312 35.9844 9.61013 35.9844 9.1875V6.125C35.9844 5.70238 36.3274 5.35938 36.75 5.35938H45.9375C46.3601 5.35938 46.7031 5.70238 46.7031 6.125V9.1875Z" fill="#FFB74D" />
                    </svg>

                    </a>
                    <p style={{ fontSize: '30px', fontWeight: '400', lineHeight: '2rem', marginTop: '0.5em' }} ><a style={{ color: 'FFFFFF' }} href="#">Desarrollo</a></p>
                  </CardContent>

                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6}
                style={{ justifyContent: 'center', display: 'flex' }}
                alignItems="center">
                <Card style={{ width: '500px', margin: '50px' }} className={classes.root}>
                  <CardContent style={{ textAlign: 'center' }}>
                    <a href="#" ><svg width="75" height="75" viewBox="0 0 50 50" style={{ marginTop: '0.5em' }} fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M46.55 9.79995H35.9333V6.53328C35.9305 4.27908 34.1042 2.45274 31.85 2.44995H17.15C14.8958 2.45274 13.0695 4.27908 13.0667 6.53328V9.79995H2.45C1.097 9.79995 0 10.8969 0 12.25V30.4288C0.00518391 31.4647 0.657959 32.3863 1.63333 32.7344V44.1C1.63333 45.453 2.73033 46.5499 4.08333 46.5499H44.9167C46.2697 46.5499 47.3667 45.453 47.3667 44.1V32.7352C48.342 32.3867 48.9952 31.4647 49 30.4288V12.25C49 10.8969 47.903 9.79995 46.55 9.79995ZM14.7 6.53328C14.7 5.18028 15.797 4.08328 17.15 4.08328H31.85C33.203 4.08328 34.3 5.18028 34.3 6.53328V9.79995H32.6667V6.53328C32.6667 6.08228 32.301 5.71662 31.85 5.71662H17.15C16.699 5.71662 16.3333 6.08228 16.3333 6.53328V9.79995H14.7V6.53328ZM31.0333 9.79995H17.9667V7.34995H31.0333V9.79995ZM45.7333 44.1C45.7333 44.551 45.3677 44.9166 44.9167 44.9166H4.08333C3.63233 44.9166 3.26667 44.551 3.26667 44.1V33.0151L21.2333 35.493V37.5666C21.2333 38.9196 22.3303 40.0166 23.6833 40.0166H25.3167C26.6697 40.0166 27.7667 38.9196 27.7667 37.5666V35.493L45.7333 33.0151V44.1ZM26.1333 37.5666C26.1333 38.0176 25.7677 38.3833 25.3167 38.3833H23.6833C23.2323 38.3833 22.8667 38.0176 22.8667 37.5666V32.6666C22.8667 32.2156 23.2323 31.85 23.6833 31.85H25.3167C25.7677 31.85 26.1333 32.2156 26.1333 32.6666V37.5666ZM47.3667 30.4288C47.3671 30.8359 47.0676 31.1812 46.6644 31.2382L46.4379 31.2694L27.7667 33.8442V32.6666C27.7667 31.3136 26.6697 30.2166 25.3167 30.2166H23.6833C22.3303 30.2166 21.2333 31.3136 21.2333 32.6666V33.8442L2.33635 31.2382C1.9332 31.1816 1.63293 30.8363 1.63333 30.4288V12.25C1.63333 11.799 1.999 11.4333 2.45 11.4333H46.55C47.001 11.4333 47.3667 11.799 47.3667 12.25V30.4288Z" fill="#FFB74D" />
                    </svg>
                    </a>
                    <p style={{ fontSize: '30px', fontWeight: '400', lineHeight: '2rem', marginTop: '0.5em' }} ><a style={{ color: 'FFFFFF' }} href="#">Consultoría</a></p>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )

        }}

      />}
    </Switch>
  );

  let arrayBread = []
  // let arrayCopia = [...breadcrumRoutes]

  // function makeBrand(array) {
  //   let objArrayBread = mapBreadscrumRoutes(array);
  //   if (objArrayBread) {
  //     arrayBread.push({ ...objArrayBread });

  //     let lengtharray = arrayBread.length;

  //     if (lengtharray > 0 && arrayBread[lengtharray - 1].children)
  //       makeBrand(arrayBread[lengtharray - 1].children);
  //   }

  // }
  // makeBrand(arrayCopia);

  const handleCloseSession = () => {
    Database.get('/logout').then(res => {
      setUser(null);
      rest.history.replace('/');

    }, err => {
      toast.error(err.message);
    })
  }

  const handleChangePass = ()=> {
    setOpenChangePass(true);
  }

  const handleCloseChangePass = () => {
    setOpenChangePass(false);
  }

  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };




  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  React.useEffect(() => {

    meRoutes();


  }, []);








  return (

    <div className={classes.wrapper}>

      <Sidebar
        handleCloseSession={() => handleCloseSession()}
        user={user}
        routes={routes}
        // logoText={"TD WMS"}
        logoText={"Cantoli Consultora"}
        logo={boxlogoside}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        {JSON.stringify(rest.alertasVencimiento)}
        <Navbar
          handleChangePass={() => handleChangePass() }
          handleCloseSession={() => handleCloseSession()}
          user={user}
          userAlertas={userAlertas}
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>

            <Breadcrumbs style={{ marginLeft: '1.5em', marginBottom: '1.5em' }} aria-label="breadcrumb">

              {arrayBread.map((elem, index) => {

                return (
                  <Link key={"bread-" + index} color="primary" to={elem.to} >
                    {elem.name}
                  </Link>
                )

              })}

            </Breadcrumbs>

            <div className={classes.container}>{switchRoutes}</div>

          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {/*getRoute() ? <Footer /> : null}
        <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
        fixedClasses={fixedClasses*/}

      </div>
      <ModalchangePass openChangePass={ openChangePass } handleClose = { handleCloseChangePass } />
    </div>
  );
}




export default Admin;
